export default {
  ordersFor: 'Orders for {day}',
  name: 'Name',
  soup: 'Soup',
  mainDish: 'Main Dish',
  price: 'Price',
  viewUsersWithoutRequests: 'View users without order',
  usersWithoutOrder: 'Users Without an Order',
};
